<template>
  <!--头部-->
  <Header :active="activeName"></Header>
  <!--栏目名/搜索-->
  <section class="container newhouse_a">
    <div class="main">
      <div class="lmName">租房</div>
      <div class="newhouse_search">
        <input type="text" placeholder="请输入区域、商圈、小区或楼盘名进行搜索" v-model="keyword">
        <button type="button" class="search_button" @click="search();"><i class="iconfont yswl-sousuo2"></i><span>搜 索</span></button>
      </div>
    </div>
  </section>
  <!--筛选条件-->
  <section class="container screening">
    <div class="main">
      <div class="screening_list">
        <div class="screening_li" v-for="(t,index) in condition" :key="index">
          <div class="screening_left">
            {{ t.name }}
          </div>
          <div class="screening_rightb">
            <a class="screening_a" :class="t.curr==0?'on':''" @click="setcondition(0,t.code,index)" href="javascript:;">全部</a>
            <a class="screening_a" :class="t.curr==tt.value?'on':''" @click="setcondition(tt.value , t.code,index)" href="javascript:;" v-for="(tt,indexs) in t.list" :key="indexs">{{ tt.name}}</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--内容列表-->
  <section class="container newhouse_bk">
    <div class="main">
      <div class="newhouse_left">
        <div class="newhouse_top">
          <div class="newhouse_top_bt">共找到<span style="color: red">{{listtotal}}</span>个出租房源</div>
          <div class="newhouse_top_order">
            <span :class="orderby==1?'on':''" @click="orderFon(1)">默认排序</span>
            <span :class="orderby==2?'on':''" @click="orderFon(2)">月租金
             <i v-if="orderby==2 && ordersort=='desc'">↓</i>
              <i v-if="orderby==2 && ordersort=='asc'">↑</i>
            </span>
            <span :class="orderby==3?'on':''" @click="orderFon(3)">更新时间
             <i v-if="orderby==3 && ordersort=='desc'">↓</i>
              <i v-if="orderby==3 && ordersort=='asc'">↑</i>
            </span>
          </div>
        </div>
        <div class="newhouse_list" v-if="datalist.length>0">
          <!--内容列表-->
          <div class="newhouse_list_li" v-for="(t,index) in datalist" :key="index">
            <a @click="showDetail(t.id)" href="javascript:void(0);">
              <div class="newhouse_list_img">
                <img :src="t.img" alt="" @error="defaultBackImg">
              </div>
              <div class="newhouse_list_rights">
                <div class="newhouse_list_titles">
                  {{t.title}}
                </div>
                <div class="newhouse_list_nr">
                  <div class="newhouse_list_sp">
                    <li><i class="iconfont yswl-dizhi"></i>{{t.yfdistrict.name}}</li>
                    <li><i class="iconfont yswl-shouye"></i><span class="newhouse_span">{{t.zhuangxiu_text}}</span><span class="newhouse_span">{{t.area}}m²</span></li>
                    <li><i class="iconfont yswl-shijian"></i>{{t.update_time_text}}</li>
                    <li><span class="tag" v-for="(v,indexs) in t.tags">4</span></li>
                  </div>
                  <div class="newhouse_list_price">
                    <span>租金<i>{{t.price}}元/月</i></span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div class="newhouse_list" v-if="huoqv == 1 && datalist.length==0">
          <ul class="list-house" style="text-align: center;margin-top: 10px;">
            <!--搜索无结果时-->
            <div class="no-result">
              <div class="img">
                <img src="@/assets/images/nulldata.png">
              </div>
              <p>非常抱歉，搜索不到相关楼盘</p>
              <span>您可以尝试扩大搜索范围，或更改搜索关键词</span>
            </div>
          </ul>
        </div>
      </div>

      <div class="newhouse_right">
        <div class="newhouse_r_bk">
          <div class="newhouse_rectitle">
            推荐楼盘
          </div>
          <div class="newhouse_tjlp">
            <li v-for="(t,index) in tjlplist.slice(0,3)" :key="index">
              <a @click="tjshowDetail(t.id)" href="javascript:void(0);">
                <div class="newhouse_tjlp_img"><img :src="t.total_img" alt="" @error="defaultBackImg"></div>
                <div class="newhouse_tjlp_bt">
                  <span class="newhouse_span_titles">{{t.name}}</span>
                  <span class="newhouse_span_jgs">{{t.b_price}}/元m²</span>
                </div>
              </a>
            </li>
          </div>
        </div>

        <div class="newhouse_r_bk">
          <div class="newhouse_rectitle">
            新开楼盘
          </div>
          <div class="newhouse_xklp">
            <li v-for="(t,index) in xklplist.slice(0,3)" :key="index">
              <a @click="tjshowDetail(t.id)" href="javascript:void(0);">
                <div class="newhouse_tjlp_img"><img :src="t.total_img" alt="" @error="defaultBackImg"></div>
                <div class="newhouse_tjlp_bt">
                  <span class="newhouse_span_titles">{{t.name}}</span>
                  <span class="newhouse_span_jgs">{{t.b_price}}/元m²</span>
                </div>
              </a>
            </li>
          </div>

        </div>
      </div>
      <!--分页-->
      <div class="list_page">
        <div class="list_page_link" id="list_page_link" v-html="page" @click="setpage($event)">
        </div>
        <div class="list_page_but" >
                <span class="list_page_left" @click="prepage()">
                    <i class="iconfont yswl-icon-jiantou2"></i>
                </span>
          <span class="list_page_right" @click="tonextpage()">
                    <i class="iconfont yswl-icon-jiantou1"></i>
                </span>
        </div>
        <div class="list_page_but jump" >
          到第<input type="text" class="u-num" v-model="nextpage">页<a class="gobtn" href="javascript:void(0)" @click="gobtn()">确定</a>
        </div>
      </div>
    </div>
  </section>
  <!--猜你喜欢-->
  <section class="container guessYouLike">
    <div class="main">
      <div class="guessYouLike_title">猜你喜欢</div>
      <div class="guessYouLike_list">
        <el-row :gutter="10">

          <el-col :span="6" v-for="(t,index) in youlikelist.slice(0,4)"  :key="index">
            <div class="guessYouLike_div">
              <a @click="nhshowDetail(t.id)" href="javascript:void(0);">
                <div class="guessYouLike_img">
                  <img :src="t.total_img" alt="" @error="defaultBackImg">
                </div>
                <div class="guessYouLike_info">
                  <div class="guessYouLike_a">
                    <span class="guessYouLike_bt">{{t.name}}</span>
                  </div>
                  <div class="guessYouLike_b">
                    <span><i>{{t.b_price}}元/m²</i></span>
                  </div>
                </div>
              </a>
            </div>
          </el-col>

        </el-row>
      </div>
    </div>
  </section>
  <!--底部-->
  <Footer></Footer>
  <!--浮动客服-->
  <OnlineMsg></OnlineMsg>
</template>
<script>
import "@/assets/css/newhouse.css"
import {ref} from "vue"
//公共文件 头部/底部
import Header from "@/components/public/Header.vue"
import Footer from "@/components/public/Footer.vue"
import OnlineMsg from "@/components/public/OnlineMsg.vue"

//接口
import axios from 'axios'
import global from "@/global";

export default{
  name: 'List',
  components: {
    Header,
    Footer,
    OnlineMsg,
  },
  setup(){
    //导航高亮标识
    const activeName = ref('lease')

    //排序方式
    // const ordernum = ref('1')
    // const orderFon = (index)=>{
    //   ordernum.value = index;
    // }

    return{
      activeName,
      // ordernum,
      // orderFon,
      // ordernum,
      // orderFon,
      // location,
    }
  },
  data(){
    return{
      nextpage:2,
      huoqv:0,
      keyword:'',
      ordersort:'desc',
      orderby:1,
      condition:[],
      totalPage:0,
      currentpage:1,
      page:'',
      //imgip:'http://hzyf.oss-cn-shanghai.aliyuncs.com',
      globalUrl: global.httpUrl,
      //内容列表
      listtotal:0,
      datalist:[],
      //猜你喜欢
      youlikelist:[],
      //推荐楼盘
      tjlplist:[],
      //新开楼盘
      xklplist:[],
      district_id:0,
      price:0,
      area:0,
    }
  },
  watch: {
    $route (to, from) {
      this.$router.go(0)
    }
  },
  created() {
    this.keyword = this.$route.query.keyword;
    const that=this;
    this.getdatalist();
    this.getconditionlist();
    this.getteRecommend();
  },
  methods:{
    gobtn(){
      this.currentpage = this.nextpage;
      if(this.nextpage+1 >= this.totalPage){
        this.nextpage = this.totalPage;
      }else{
        this.nextpage = this.nextpage+1;
      }
      this.getdatalist();
    },
    defaultBackImg() {
      if(event.type == "error") {
        event.target.src= require("../../assets/images/noimg.png")
      }
    },
    search(){
      if(this.keyword == '' || this.keyword == undefined){
        // this.$message({
        //   showClose: true,
        //   message: '请输入搜索关键词',
        //   type: 'error',
        //   duration:2000,
        //   center:true,
        //   offset:150
        // });
        // return false;
      }
      this.$router.push({
        path: "/lease",
        query: {
          keyword: this.keyword,
        },
      });
    },
    orderFon(type){
      const that=this;
      that.orderby = type;
      if(that.ordersort == 'asc'){
        that.ordersort = 'desc';
      }else{
        that.ordersort = 'asc';
      }
      that.getdatalist();
    },
    getteRecommend(){
      const that=this;
      axios.get(this.globalUrl+'/api/newhouse/getRecommend')
          .then(function (response) {
            if(response.data.code == 1){
              //console.log('aaa',response.data)
              that.tjlplist = response.data.data.hotRecommend
              that.xklplist = response.data.data.newRecommend
              that.youlikelist = response.data.data.bottomRecommend
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    showDetail(id){
      this.$router.push({
        path: `/leaseshow/`+id
      })
    },
    nhshowDetail(id){
      this.$router.push({
        path: `/nhshow/`+id
      })
    },
    tjshowDetail(id){
      this.$router.push({
        path: `/nhshow/`+id
      })
    },
    //筛选
    setcondition(value,code,indexs){
      if(code == 'price'){
        this.price = value;
      }
      if(code == 'area'){
        this.area = value;
      }
      if(code == 'district_id'){
        this.district_id = value;
      }
      var condition = this.condition;
      condition.filter(function(item,index,self){
        if(index == indexs){
          item.curr = value;
        }
        return item;
      })
      this.currentpage = 1;
      this.getdatalist();
      //console.log('condition',condition)
    },
    //获取筛选列表
    getconditionlist(){
      const that=this;
      axios.get(this.globalUrl+'/api/home/getTiaojian?type=lease')
          .then(function (response) {
            if(response.data.code == 1){
              var condition = response.data.data;
              //console.log('response.data.data',response.data.data)
              for(var i = 0; i < condition.length; i++){
                condition[i].curr = 0;
              }
              that.condition = condition;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    prepage(){
      const that=this;
      if(that.currentpage > 1){
        that.currentpage = parseInt(that.currentpage) - 1;
        that.getdatalist();
      }
    },
    tonextpage(){
      const that=this;
      // console.log('that.currentpage',that.currentpage)
      // console.log('that.listtotal',that.listtotal)
      if(that.currentpage < that.totalPage){
        that.currentpage = parseInt(that.currentpage) + 1;
        that.getdatalist();
      }
    },
    setpage(event){
      if(event.target.nodeName === 'SPAN'){
        console.log(event.srcElement.attributes[0].nodeValue)
        // 获取触发事件对象的属性
        const that=this;
        that.currentpage = event.srcElement.attributes[0].nodeValue;
        that.getdatalist();
      }
    },
    //楼讯
    getdatalist(){
      const that=this;
      var currentpage = that.currentpage;
      axios.get(this.globalUrl+'/api/lease/index',{
        params: {
          page:currentpage,
              orderby:that.orderby,
              sort:that.ordersort,
              keyword:that.keyword,
              district_id:that.district_id,
              price:that.price,
              area:that.area,
        }
      }).then(function (response) {
            if(response.data.code == 1){
              that.listtotal = response.data.data.total;
              that.datalist = response.data.data.list;
              that.pagination(10,currentpage,that.listtotal);
              that.huoqv = 1;
              window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  }
              );

            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    pagination(perPage,current,totalCount) {
      const that=this;
      //设置表格总页数
      var totalPage=0;//列表的总页数
      var pageSize = perPage;
      if (totalCount/pageSize > parseInt(totalCount/pageSize)){
        totalPage = parseInt(totalCount/pageSize)+1;
      }else{
        totalPage = parseInt(totalCount/pageSize);
      }

      var currentPage=current;
      var startRow=(currentPage-1)*pageSize+1;
      var endRow=(currentPage*pageSize > totalCount ? totalCount : currentPage*pageSize);
      that.totalPage = totalPage;
      that.createBtns(totalPage , current);
    },
    createBtns(totalPages , current) {
      const that = this;
      var tempStr = "";
      current = parseInt(current);
      if (totalPages <= 5) {
        for (var pageIndex = 1; pageIndex < totalPages + 1; pageIndex++) {
          if (current == pageIndex) {
            tempStr += "<span class='on'>" + pageIndex + "</span>";
          } else {
            tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
          }
        }
      } else {
        if (current < 5) {
          for (var pageIndex = 1; pageIndex <= 5; pageIndex++) {
            if (current == pageIndex) {
              tempStr += "<span class='on'>" + pageIndex + "</span>";
            } else {
              tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
            }
          }
          tempStr += '<i>...</i>';
          tempStr += "<span data-page=" + totalPages + ">" + totalPages + "</span>";
        } else if (current > totalPages - 4) {
          tempStr += "<span data-page='1'>" + 1 + "</span>";
          tempStr += '<i>...</i>';
          for (var pageIndex = totalPages - 4; pageIndex <= totalPages; pageIndex++) {
            if (current == pageIndex) {
              tempStr += "<span class='on'>" + pageIndex + "</span>";
            } else {
              tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
            }
          }
        }else if(current == totalPages - 4){
          tempStr += "<span data-page='1'>" + 1 + "</span>";
          tempStr += '<i>...</i>';
          for (var pageIndex = current - 1; pageIndex <= current; pageIndex++) {
            if (current == pageIndex) {
              tempStr += "<span class='on'>" + current + "</span>";
            } else {
              tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
            }
          }
          for (var pageIndex = current + 1; pageIndex <= current + 1; pageIndex++) {
            tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
          }

          tempStr += '<i>...</i>';
          tempStr += "<span data-page=" + totalPages + ">" + totalPages + "</span>";
        }else if (current >= 5 && current < totalPages - 4) {
          tempStr += "<span data-page='1'>" + 1 + "</span>";
          tempStr += '<i>...</i>';
          for (var pageIndex = current - 1; pageIndex <= current; pageIndex++) {
            if (current == pageIndex) {
              tempStr += "<span class='on'>" + current + "</span>";
            } else {
              tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
            }
          }
          for (var pageIndex = current + 1; pageIndex <= current + 1; pageIndex++) {
            tempStr += "<span data-page=" + pageIndex + ">" + pageIndex + "</span>";
          }

          tempStr += '<i>...</i>';
          tempStr += "<span data-page=" + totalPages + ">" + totalPages + "</span>";
        }
      }
      that.page = tempStr;
    },
  }
}
</script>
<style scoped>
.gobtn{
  margin-left: 5px;
  text-align: center;
  background: #FF9D66;
  color: #fff;
  border-color: #FF9D66;
  float: left;
  line-height: 30px;
  font-size: 12px;
  border-radius: 5px;
  width: 50px;
}
.u-num{
  height: 32px;
  width: 32px;
  text-align: center;
  border: #ddd 1px solid;
  border-radius: 4px;
  margin: 0 5px;
}
.jump{    float: left;
  line-height: 32px;
  height: 32px;
  font-size: 12px;
  color: #999;
  padding: 0 12px;}
.list_page{
  justify-content: center;
  margin-bottom: 10px;
}
.list_page_link{
  width: 30%;
}
.list_page_left{
  width: 36px;
  height: 36px;
  line-height: 36px;
}
.list_page_right{
  width: 36px;
  height: 36px;
  line-height: 36px;
}
.newhouse_bk .main{
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.newhouse_a{
  height: 128px;
}
.newhouse_a .main{
  display: flow-root;
}
.lmName{
  float: left;
  font-size: 36px;
  line-height: 40px;
  margin-top: 44px;
  color: #1b1b1b;
}

.newhouse_search{
  float: right;
  width: 720px;
  height: 48px;
  background: #F7F7F7;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  margin-top: 40px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.newhouse_search input{
  width: 594px;
  height: 100%;
  border: none;
  background: none;
  padding: 0 20px;
}

.search_button{
  width: 125px;
  height: 100%;
  background: #FF9D66;
  color: #ffffff;
  border: none;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search_button i.iconfont{
  font-size: 14px;
  font-weight: 600;
  margin-right: 8px;
  margin-top: 3px;
}
</style>